module.exports = __webpack_public_path__ + "img/kh27.29edd1ef.png";